import { flatten as flattenTree } from '@/utils/tree.js'

export function mergeBreakdowns(oldBreakdownDims, newBreakdownDims) {
  // Return an state.query.breakdowns object with reused values from the last state if it's possible, else with the dimension first option value as fallback value
  return newBreakdownDims.reduce((acum, dim) => {
    const defaultOpt = dim.options.find(opt => opt.isDefault)?.id || dim.options[0].id
    const options = flattenTree(dim.options)
    const availables = Object.fromEntries(options.map(d => [d.id, true]))
    const legacy = oldBreakdownDims[dim.id]
    acum[dim.id] = (availables[legacy] && legacy) || defaultOpt
    return acum
  }, {})
}

export function mergeTimes(oldTime, newTime) {
  return [
    oldTime[0] > newTime[0] && oldTime[0] < newTime[1] ? oldTime[0] : newTime[0],
    oldTime[1] < newTime[1] && oldTime[1] > newTime[0] ? oldTime[1] : newTime[1],
  ].map(d => parseInt(d, 10))
}
